<template>
    <div class="phone">
        <!--内容区域-->
        <BottomTabPageView />
        <!--bottomtabbar-->
        <BottomTabBarView class="bottomtabbar" :appObj="appObj" />

        <el-button type="primary" class="global-button" @click="handleClickGlobal">全局配置</el-button>
    </div>
</template>

<script>
import BottomTabPageView from '@/views/Decoration/View/BottomTabPageView.vue';
import BottomTabBarView from '@/views/Decoration/DecorationGroup/BottomTabBar/BottomTabBarView'
import emitter from '@/utils/eventbus';
export default {
    name: "DecorationApp",
    props: ['appObj'],
    components: {
        BottomTabPageView,
        BottomTabBarView,
    },
    methods: {
        handleClickGlobal() {
            emitter.emit('onComponentChange', { type: 'global',name: '全局配置',  component: this.appObj })
        }
    }
}
</script>

<style scoped lang="less">
.phone {
    position: relative;
    margin: 0 auto;
    width: 375px;
    height: 667px;
    background: #fff;
    box-shadow: -10px 20px 30px 0px rgba(192, 197, 205, 0.8);

    .bottomtabbar {
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
    }

    .global-button {
        position: absolute;
        top: 0;
        right: 100%;
        margin-right: 20px;
    }
}

.navigationbar-edit {
    position: absolute;
    font-size: small;
    color: #333;
    left: 100%;
    top: 0;
    z-index: 999;
}

//测试div
.parent {
    width: 200px;
    height: 200px;
    background-color: aquamarine;
    position: relative;
    overflow: auto;

    div {
        width: 50%;
        height: 50%;
        background-color: lightcoral;
        position: absolute;
        left: 100%;
    }
}
</style>